module.exports = __webpack_public_path__ + "img/NC.dbf94032.svg";